import classNames from 'classnames';
import React from 'react';
import MembershipTopic from './MembershipTopic';
import * as styles from './MembershipTopics.module.scss';
import type { TopicWithMembershipTopics } from './useMembershipTopics';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const MEMBERSHIP_TOPICS_TOPIC_FRAGMENT = gql(`
  fragment MembershipTopics_topic on Topic {
    id
    ...MembershipTopic_topic
  }
`);

interface MembershipTopicsProps {
  membershipTopics:
    | TopicWithMembershipTopics<
        DocumentType<typeof MEMBERSHIP_TOPICS_TOPIC_FRAGMENT>
      >[]
    | null;
  interactionsDisabled?: boolean;
}

const MembershipTopics = ({
  membershipTopics,
  interactionsDisabled,
}: MembershipTopicsProps) => {
  return (
    <ul
      className={classNames(styles.content, {
        [styles.interactionsDisabled]: interactionsDisabled,
      })}
    >
      {membershipTopics && membershipTopics.length > 0 ? (
        membershipTopics.map((membershipTopic) => (
          <li key={membershipTopic.id}>
            <MembershipTopic topic={membershipTopic} showBreadcrumbs />
          </li>
        ))
      ) : (
        <div className={styles.empty}>No memberships yet</div>
      )}
    </ul>
  );
};

export default MembershipTopics;
